import axios from 'axios'
import AscentiaService from './ascentiaService'

const values = {}

const getters = {}

const saves = {
  plotlyToken(data) {
    const url = '/plotly'
    return axios.post(url, data)
  },

  dashSelections(data) {
    const url = '/Plotly/DashSelections'
    return axios.post(url, data)
  },

  createIssueFromDash(data) {
    return axios.post('/plotly/CreateNewIssue', data)
  },

  saveRepeaterDashSelections(data) {
    const url = '/Plotly/DashSelections'
    return axios.post(url, data)
  },

}

const deletes = {}

export default class PlotlyService extends AscentiaService {
  get values() {
    return values
  }

  get getters() {
    return getters
  }

  get saves() {
    return saves
  }

  get deletes() {
    return deletes
  }
}
